/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import "./ContactUs.css";
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from "lucide-react";
import arrow from "../../assets/icons/Vector.png"
import apiManage from "../ManageApi/ApI";
import Breadcrumb from "../Pages/Breadcrumb";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    termsAccepted: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");
    setSuccessMessage("");

    try {
      // Ensure the correct endpoint name and API configuration
      const response = await apiManage.post("/countact-us", formData); // POST without 'method' and 'headers' if API.js already handles this

      if (response.status === 200) {
        setSuccessMessage(t('contact.msg-sent'));
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          description: "",
        }); // Reset form
      } else {
        // Handle API errors
        setError(t('custom.err'));
      }
    } catch (err) {
      console.error("API Error:", err); // Log error for debugging
      setError(t('custom.err'));
    }

    setIsSubmitting(false);
  };
  const [isBranchOpen, setIsBranchOpen] = useState({
    dubai: false,
    cairo: false,
  });

  const toggleBranch = (branch) => {
    setIsBranchOpen({ ...isBranchOpen, [branch]: !isBranchOpen[branch] });
  };

  return (
    <>

      <Breadcrumb pages={[t("routes.contact-us")]} />
      <div className="container">
        <div className="contact-part row justify-content-between">
          {/* Contact Form */}

          <div className="contact-form-section col-lg-4">
            <form className="contact-form" onSubmit={handleSubmit}>
              <label htmlFor="first_name">{t('contact.first-name')}</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                value={formData.first_name}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="last_name">{t('contact.last-name')}</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="email">{t('contact.email')}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="phone">{t('contact.phone')}</label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />

              <label htmlFor="description"> {t('contact.message')}</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
              ></textarea>

              {error && <div className="error-message">{error}</div>}
              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}
              <label className="terms">
                <input type="checkbox" required style={{ marginLeft: "5px" }} />
                <span style={{}}>
                  {t('contact.i-agree')}

                  <Link to="/privacy" className="" id="">
                    {""} {t('routes.privacy-policy')}
                  </Link>
                </span>
              </label>
              <button
                type="submit"
                className="btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? `${t('custom.sending')}` : t('custom.send')}
              </button>
            </form>
          </div>
          <div className="contact-map col-lg-8">
            {/* Google Map Section */}
            <div className="">
              <div className="map-container position-relative">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.1293790565296!2d46.6964526!3d24.756752799999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2efd95adf123fd%3A0x7161b56ec34ca583!2z2YXYudmH2K8g2KLZitmB2YjYsdmKINmE2YTYqtiv2LHZitioINin2YTYudin2YTZig!5e0!3m2!1sar!2seg!4v1698505023618!5m2!1sar!2seg"
                  style={{ height: '450px' }}
                  height="450"
                  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
              </div>
            </div>

            {/* Contact Info Section */}
            <div className="">
              <div className="flex flex-col md:flex-row justify-between">

                <div className=" title-info row justify-content-between">
                  <p className="col-lg-4 col-md-6">
                    <MapPin className="inline-block" />
                    <strong>{t('contact.main-branch')}</strong>
                    <br />
                    <span>{t('contact.address')}</span>
                  </p>

                  <p className="col-lg-3 col-md-6">
                    <Mail className="inline-block" />
                    <strong>{t('contact.email')}</strong>
                    <br />
                    <a href="mailto:info@ivorytraining.com" className="">
                      info@ivorytraining.com
                    </a>
                  </p>

                  <p className="col-lg-3 col-md-6">
                    <Phone className="inline-block " />
                    <strong> {t('contact.phone')} </strong>
                    <br />
                    <a href="tel:+966533993220" className="text-start hover:underline" dir="ltr">
                      +966 533 993 220
                    </a>
                  </p>
                </div>

              </div>

              {/* Branches Section */}
              <div className=" branch-section">
                <button
                  onClick={() => toggleBranch("dubai")}
                  className="w-full text-left font-bold bg-gray-200 p-2 rounded"
                >
                  <span><MapPin className="inline-block" />{t('contact.dubai-br')}</span>
                  <img src={arrow} alt="arrow" />
                </button>
                {isBranchOpen.dubai && (
                  <p className="p-2 rounded mt-1" style={{ border: '1px solid #D9D9D9' }}>Dubai, UAE - Sheikh Zayed Road</p>
                )}

                <button
                  onClick={() => toggleBranch("cairo")}
                  className="w-full mt-2 text-left font-bold bg-gray-200 p-2 rounded"
                >

                  <span> <MapPin className="inline-block" />{t('contact.egy-br')}</span>

                  <img src={arrow} alt="arrow-icon" />
                </button>
                {isBranchOpen.cairo && (
                  <p className="p-2 rounded mt-1" style={{ border: '1px solid #D9D9D9' }}>Cairo, Egypt - Nasr City</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
